

	import { Component } from 'vue-property-decorator';
	import { BaseAppView } from '@shared/views/BaseAppView';
	import firebase from 'firebase';

	@Component({})
	export default class Login extends BaseAppView {


		public email: string = '';
		public password: string = '';
		public rememberMe: boolean = true;

		public $refs!: {
			form: any,
		};
		public mounted() {
			if (this.$route.query?.noauth) {
				this.notification.error('You need to be logged in to do that');
			}

			firebase.auth().onAuthStateChanged((user) => {
				if (user) {
					this.$router.push({ name: 'home' });
				}
			});
		}

		public async login() {
			try {
				this.$gtag.event('login', { method: 'Email' });
				this.loading = true;
				const result = await firebase.auth().signInWithEmailAndPassword(this.email, this.password);
				this.notification.success('Logged in successfully');
				this.$router.push({ name: 'home' });
			} catch (err) {
				this.notification.error(err.message);
			} finally {
				this.loading = false;
			}
		}


		public async loginWithFacebook() {
			// TODO: Implement this
		}


	}

